<div class="comments-row" *ngFor="let projectComment of project.comments; trackBy: trackEntityById"
     [id]="projectComment.id">
  <div class="comment-block" *ngIf="!(editItem === projectComment.id) && !projectComment.deleted">
    <div class="parent-comm">
      <div class="comment-user">
        <div class="avatar-block">
          <div class="word-avatar" style.background-color="#{{projectComment.user.bgColor}}">
            <div class="short-name">
              {{projectComment.user.shortCode}}
            </div>
          </div>
        </div>
        <span class="user-name">{{projectComment.user.name}} </span>
        <span class="time"
              *ngIf="!projectComment.moreThanYear">{{projectComment.createdTime | date: 'MMM dd'}}
          at
          {{projectComment.createdTime | date: 'H:mm aaa'}}
              </span>
        <span class="time"
              *ngIf="projectComment.moreThanYear">{{projectComment.createdTime | date: 'MMM dd YYYY'}}
          at
          {{projectComment.createdTime | date: 'H:mm aaa'}}
              </span>
      </div>

      <div class="comment-title-block my-comment" *ngIf="projectComment.user.id === currentUser.id">
        <div class="comment-title" appUserMentionContent [content]="projectComment.text"
             [mentions]="projectComment.mentions" (click)="editComment(projectComment)">
          {{projectComment.text}}</div>

        <button mat-button class="task-button" (click)="createTask(projectComment)" *ngIf="!isMobile">Create
          Task
        </button>

        <button mat-button class="reply-button" (click)="replyComment(projectComment)">
          <mat-icon class="reply-button-icon">reply</mat-icon>
        </button>
      </div>


      <div class="comment-title-block" *ngIf="projectComment.user.id !== currentUser.id">
        <div class="comment-title" appUserMentionContent [content]="projectComment.text"
             [mentions]="projectComment.mentions">
        </div>

        <button mat-button class="task-button" (click)="createTask(projectComment)" *ngIf="!isMobile">Create
          Task
        </button>
        <button mat-button class="reply-button" (click)="replyComment(projectComment)">
          <mat-icon class="reply-button-icon">reply</mat-icon>
        </button>
      </div>
    </div>
    <div class="reply-comments" *ngIf="projectComment.replies?.length > 0">
      <div class="comments-row"
           *ngFor="let replyProjectComment of projectComment.replies; trackBy: trackEntityById"
           [id]="replyProjectComment.id">
        <div class="comment-block"
             *ngIf="!(editReplyItem === replyProjectComment.id) && !replyProjectComment.deleted">
          <div class="child-comm">
            <div class="comment-user">
              <div class="avatar-block">
                <div class="word-avatar" style.background-color="#{{replyProjectComment.user.bgColor}}">
                  <div class="short-name">
                    {{replyProjectComment.user.shortCode}}
                  </div>
                </div>
              </div>
              <span class="user-name">{{replyProjectComment.user.name}} </span>
              <span class="time"
                    *ngIf="!replyProjectComment.moreThanYear">{{replyProjectComment.createdTime | date: 'MMM dd'}}
                at
                {{replyProjectComment.createdTime | date: 'H:mm aaa'}}
              </span>
              <span class="time"
                    *ngIf="replyProjectComment.moreThanYear">{{replyProjectComment.createdTime | date: 'MMM dd YYYY'}}
                at
                {{replyProjectComment.createdTime | date: 'H:mm aaa'}}
              </span>
            </div>

            <div class="comment-title-block my-comment"
                 *ngIf="replyProjectComment.user.id === currentUser.id">
              <div class="comment-title" appUserMentionContent [content]="replyProjectComment.text"
                   [mentions]="replyProjectComment.mentions"
                   (click)="editReplyComment(replyProjectComment)">
                {{replyProjectComment.text}}</div>

              <button mat-button class="task-button" (click)="createTask(replyProjectComment)"
                      *ngIf="!isMobile">Create Task
              </button>
              <button mat-button class="reply-button"
                      (click)="replyComment(projectComment, replyProjectComment)">
                <mat-icon class="reply-button-icon">reply</mat-icon>
              </button>
            </div>


            <div class="comment-title-block" *ngIf="replyProjectComment.user.id !== currentUser.id">
              <div class="comment-title" appUserMentionContent [content]="replyProjectComment.text"
                   [mentions]="replyProjectComment.mentions">
              </div>

              <button mat-button class="task-button" (click)="createTask(replyProjectComment)"
                      *ngIf="!isMobile">Create Task
              </button>
              <button mat-button class="reply-button"
                      (click)="replyComment(projectComment, replyProjectComment)">
                <mat-icon class="reply-button-icon">reply</mat-icon>
              </button>
            </div>
          </div>
        </div>


        <div class="comment-block" *ngIf="replyProjectComment.deleted"
             [ngClass]="{'deleted-comment': replyProjectComment.deleted}"
             pTooltip="Deleted {{replyProjectComment.editTime | date: 'MMM dd'}} {{replyProjectComment.editTime | date: 'H:mm aaa'}} "
             tooltipPosition="bottom">
          <div class="child-comm">
            <div class="comment-user">
              <div class="avatar-block">
                <div class="word-avatar" style.background-color="#{{replyProjectComment.user.bgColor}}">
                  <div class="short-name">
                    {{replyProjectComment.user.shortCode}}
                  </div>
                </div>
              </div>
              <span class="user-name">{{replyProjectComment.user.name}} </span>
              <span class="time"
                    *ngIf="!replyProjectComment.moreThanYear">{{replyProjectComment.createdTime | date: 'MMM dd'}}
                at
                {{replyProjectComment.createdTime | date: 'H:mm aaa'}}
              </span>
              <span class="time"
                    *ngIf="replyProjectComment.moreThanYear">{{replyProjectComment.createdTime | date: 'MMM dd YYYY'}}
                at
                {{replyProjectComment.createdTime | date: 'H:mm aaa'}}
              </span>
            </div>

            <div class="comment-title-block">
              <div class="comment-title" appUserMentionContent [content]="replyProjectComment.text"
                   [mentions]="replyProjectComment.mentions">
              </div>
            </div>
          </div>
        </div>

        <div class="save-comment-block" *ngIf="editReplyItem === replyProjectComment.id">
          <div class="comment-user">
            <div class="avatar-block">
              <div class="word-avatar" style.background-color="#{{replyProjectComment.user.bgColor}}">
                <div class="short-name">
                  {{replyProjectComment.user.shortCode}}
                </div>
              </div>
            </div>
            <span class="user-name">{{replyProjectComment.user.name}} </span>
            <span class="time"
                  *ngIf="!replyProjectComment.moreThanYear">{{replyProjectComment.createdTime | date: 'MMM dd'}}
              at
              {{replyProjectComment.createdTime | date: 'H:mm aaa'}}
              </span>
            <span class="time"
                  *ngIf="replyProjectComment.moreThanYear">{{replyProjectComment.createdTime | date: 'MMM dd YYYY'}}
              at
              {{replyProjectComment.createdTime | date: 'H:mm aaa'}}
              </span>
          </div>
          <app-edit-comment [comment]="replyProjectComment"
                            (updateAction)="onUpdateReplyItem(projectComment, $event)" [users]="users"
                            (deleteAction)="deleteReplyComment(projectComment, replyProjectComment)"
                            (closeAction)="onEditBlockClosed()">
          </app-edit-comment>
        </div>
      </div>

    </div>

    <div *ngIf="projectComment.id === replyItem">
      <app-reply-comment [comment]="projectComment" (closeAction)="onEditBlockClosed()" [users]="users">
      </app-reply-comment>
    </div>
  </div>

  <div class="comment-block" *ngIf="projectComment.deleted" [ngClass]="{'deleted-comment': projectComment.deleted}"
       pTooltip="Deleted {{projectComment.editTime | date: 'MMM dd'}} {{projectComment.editTime | date: 'H:mm aaa'}} "
       tooltipPosition="bottom">
    <div class="parent-comm">
      <div class="comment-user">
        <div class="avatar-block">
          <div class="word-avatar" style.background-color="#{{projectComment.user.bgColor}}">
            <div class="short-name">
              {{projectComment.user.shortCode}}
            </div>
          </div>
        </div>
        <span class="user-name">{{projectComment.user.name}} </span>
        <span class="time"
              *ngIf="!projectComment.moreThanYear">{{projectComment.createdTime | date: 'MMM dd'}}
          at
          {{projectComment.createdTime | date: 'H:mm aaa'}}
              </span>
        <span class="time"
              *ngIf="projectComment.moreThanYear">{{projectComment.createdTime | date: 'MMM dd YYYY'}}
          at
          {{projectComment.createdTime | date: 'H:mm aaa'}}
              </span>
      </div>

      <div class="comment-title-block">
        <div class="comment-title" appUserMentionContent [content]="projectComment.text"
             [mentions]="projectComment.mentions">
        </div>
      </div>

    </div>
  </div>

  <div class="save-comment-block" *ngIf="editItem === projectComment.id">
    <div class="comment-user">
      <div class="avatar-block">
        <div class="word-avatar" style.background-color="#{{projectComment.user.bgColor}}">
          <div class="short-name">
            {{projectComment.user.shortCode}}
          </div>
        </div>
      </div>
      <span class="user-name">{{projectComment.user.name}} </span>
      <span class="time"
            *ngIf="!projectComment.moreThanYear">{{projectComment.createdTime | date: 'MMM dd'}}
        at
        {{projectComment.createdTime | date: 'H:mm aaa'}}
              </span>
      <span class="time"
            *ngIf="projectComment.moreThanYear">{{projectComment.createdTime | date: 'MMM dd YYYY'}}
        at
        {{projectComment.createdTime | date: 'H:mm aaa'}}
              </span>
    </div>
    <app-edit-comment [comment]="projectComment" (updateAction)="onUpdateItem($event)" [users]="users"
                      (deleteAction)="deleteComment(projectComment)" (closeAction)="onEditBlockClosed()">
    </app-edit-comment>
  </div>

</div>

<div class="new-comment-block">
  <ng-container *ngIf="editItem < 0 && replyItem < 0">
    <app-add-comment (closeAction)="onEditBlockClosed()" [users]="users">
    </app-add-comment>
  </ng-container>
</div>
